/**
 * Created by Owner on 2016/8/22.
 */
import {Component, Input, Output, EventEmitter} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {LotteryMath} from "./lotteryMath";

@Component({
  selector: 'lottery-math-textSelect',
  templateUrl: 'textSelect.html',
})
export class TextSelectComponent extends LotteryMathZXFSComponent implements LotteryMath {
  selectArray: any = [];
  @Output() onTotal: EventEmitter<any> = new EventEmitter<any>();

  @Input()
  set selectAreaOption(selectAreaOption: any) {
    this.selectArray = [];
    selectAreaOption["layout"][0]["no"].split('|').forEach((value)=> {
      this.selectArray.push({
        text: value,
        isSelect: false
      });
    });
    this._selectAreaOption = selectAreaOption;
  }

  initView() {
    this.selectArray = [];
    this._selectAreaOption["layout"][0]["no"].split('|').forEach((value)=> {
      this.selectArray.push({
        text: value,
        isSelect: false
      });
    });
  }

  selectToggle(index: number) {
    this.selectArray[index].isSelect = !this.selectArray[index].isSelect;
    this.changeTotal();
  }

  changeTotal() {
    let selectNo: any = [];
    this.selectArray.forEach(item => {
      if (item.isSelect) {
        selectNo.push(item.text);
      }
    });

    this.onTotal.emit({
      total: selectNo.length,
      defaultPosition: this.defaultPosition,
      selectNo: selectNo,
      type: 'digitalts'
    });
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/textSelect.ts